import { render } from "./NavBase.vue?vue&type=template&id=4dab3988&scoped=true"
import script from "./NavBase.vue?vue&type=script&lang=js"
export * from "./NavBase.vue?vue&type=script&lang=js"

import "./NavBase.vue?vue&type=style&index=0&id=4dab3988&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dab3988"]])

export default __exports__